<template>
  <v-text-field :label="label" outlined dense :type="type"
    autocomplete="new-password"
    :prepend-inner-icon="prependIcon" :append-icon="appendIcon"
    @click:append="togglePassword" :rules="rules" :error-messages="err"
    @input="$emit('input', $event)" :value="value">
  </v-text-field>
</template>

<script>
export default {
  name: 'settings-user-field',
  data () {
    return {
      type: 'text'
    }
  },
  props: {
    label: {
      type: String
    },
    value: {
      type: String
    },
    icon: {
      type: String
    },
    password: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array
    },
    err: {
      type: Array
    }
  },
  mounted () {
    if (this.password) {
      this.type = 'password'
    }
  },
  computed: {
    prependIcon: function () {
      return this.icon ? 'mdi-' + this.icon : ''
    },
    appendIcon: function () {
      return this.password ? 'mdi-eye' : ''
    }
  },
  methods: {
    togglePassword: function () {
      this.type = this.type === 'password'
        ? 'text'
        : 'password'
    }
  }
}
</script>

<style scoped>
</style>
